module.exports = __webpack_public_path__ + "media/Video 6.beee8968.mp4";